import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import AppBar from "../../../../common/AppBar";
import { TextField, TextArea, CheckboxField } from "../../../../common/FormFields";
import SignatureAuthSection from "../../../../pages/ApplicationSetup/components/SignatureAuthSection";
import LogoUpload from "../../../ApplicationSetup/components/LogoUpload";
import CustomSelect from "../../../ApplicationSetup/components/CustomSelect";
import "../../../../pages/ApplicationSetup/ApplicationSetup.css";
import "./AppSetupPreview.css";
import { getAuditTrailByid } from "../../../../redux/auditTrailSlice";


const AppSetupPreview = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { audit_trail_id } = useParams();
  const [data, setData] = useState({});

  useEffect(() => {
    if (audit_trail_id) {
        (async () => {
            try {
                const resp = await dispatch(getAuditTrailByid({ id: audit_trail_id }));
                const results = resp?.payload?.data?.results || {};
                // Extract data: potentially in version_content or root
                const sourceData = results.version_content.formData || results;
                setData(sourceData);
            } catch (error) {
                console.error("Failed to fetch audit trail data", error);
            }
        })();
    }
  }, [dispatch, audit_trail_id]);

  // Extract data fields
  const {
      action_heading,
      company_name,
      company_address,
      company_phone,
      footer,
      company_image_url,
      auto_backup_time,
      is_autobackup_enabled,
      application_time_zone,
      signature_auth_methods
  } = data || {};

  // Time parsing logic
  const parseBackupTime = (timeString) => {
      if (!timeString) return { hour: "10", minute: "10", period: "AM" };
      // Try 12-hour format first
      const timeMatch = timeString.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
      if (timeMatch) {
        return {
          hour: timeMatch[1].padStart(2, "0"),
          minute: timeMatch[2],
          period: timeMatch[3].toUpperCase(),
        };
      }
      // Try 24-hour format
      const time24Match = timeString.match(/(\d{1,2}):(\d{2})/);
      if (time24Match) {
        const hour24 = parseInt(time24Match[1], 10);
        const hour12 = hour24 % 12 || 12; // 0 becomes 12
        const period = hour24 >= 12 ? "PM" : "AM";
        return {
          hour: hour12.toString().padStart(2, "0"),
          minute: time24Match[2],
          period: period,
        };
      }
      return { hour: "10", minute: "10", period: "AM" };
  };

  const { hour: backupHour, minute: backupMinute, period: backupPeriod } = parseBackupTime(auto_backup_time);

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div className="app-setup-page">
      <AppBar
        title={action_heading}
        onBack={handleBackClick}
        showTablesDropdown={false}
        showProfileButton={false}
        buttons={[]}
        editButton={null}
      />
      <div className="app-setup-preview-container">
        <div className="signature-auth-wrapper">
          <SignatureAuthSection
            signatureMethods={signature_auth_methods || []}
            onToggleMethod={() => {}}
            disabled={true}
          />
          <div className="timezone-section">
              <label className="timezone-label">Timezone</label>
              <CustomSelect
                value={application_time_zone || "EST"}
                onChange={() => {}}
                options={[
                  { value: "EST", label: "EST" },
                  { value: "PST", label: "PST" },
                  { value: "UTC", label: "UTC" },
                  { value: "EDT", label: "EDT" },
                ]}
                disabled={true}
                audittrail={true}
                style={{ width: "150px" }}
              />
          </div>
        </div>

        <div className="form-grid" style={{ marginTop: "-30px" }}>
          <TextField
            label="Company Name"
            value={company_name || ""}
            onChange={() => {}}
            required={true}
            disabled={true}
            style={{ marginLeft: "-2px" }}
          />

          <TextField
            label="Company Address"
            value={company_address || ""}
            onChange={() => {}}
            required={true}
            disabled={true}
          />

          <TextField
            label="Company Phone"
            value={company_phone || ""}
            onChange={() => {}}
            required={true}
            disabled={true}
          />

          <LogoUpload
            previewUrl={company_image_url || ""}
            onFileSelect={() => {}}
            disabled={true}
            audittrail={true}
          />
        </div>

        <div className="footer-row">
          <TextArea
            label="Footer"
            value={footer || ""}
            onChange={() => {}}
            style={{ marginLeft: "-2px" }}
            textareaStyle={{
              width: "673px",
              height: "100px",
              borderRadius: "4px",
            }}
            minHeight="100px"
            required={true}
            disabled={true}
          />
        </div>

        <div className="auto-backup-section">
          <div className="auto-backup-heading">
            Auto Backup
          </div>
          <div className="auto-backup-row">
            <CheckboxField
              checked={!!is_autobackup_enabled}
              onChange={() => {}}
              description="Enable Auto Backup"
              disabled={true}
            />
          </div>
          {/* Always show backup time inputs if enabled, or maybe check data existence? 
              Original code checks 'enabled' boolean. */}
          {is_autobackup_enabled && (
            <div className="backup-time-container">
              <label className="backup-time-label">Set Time</label>
              <div className="backup-time-inputs-wrapper">
                <input
                  type="text"
                  className="backup-hour-input"
                  value={backupHour}
                  disabled={true}
                  readOnly
                />
                <span className="backup-time-separator">:</span>
                <input
                  type="text"
                  className="backup-minute-input"
                  value={backupMinute}
                  disabled={true}
                  readOnly
                />
                <CustomSelect
                  value={backupPeriod}
                  options={[
                    { value: "AM", label: "AM" },
                    { value: "PM", label: "PM" },
                  ]}
                  disabled={true}
                  style={{ width: "80px" }}
                  onChange={() => {}}
                  audittrail={true}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AppSetupPreview;
